import { rTabs } from "./code/index";

const someCSSCodeExample = rTabs(`
body {
\tpadding: 0;
\tmargin: 0;
\tbox-sizing: border-box;
\tfont-family: Arial Rounded MT, Arial, Helvetica, sans-serif;
}

.background {
\tcolor: white;
\theight: 100vh;
\twidth: 100vw;
\tbackground: #123;
\tdisplay: flex;
\tjustify-content: center;
\talign-items: center;
\tflex-direction: column
}

.tagline {
\tmargin-top: 5px;
}

.logo {
\tfont-size: 50px;
}

.logo::before{
\tcontent: "{";
\tcolor: green;
}

.logo::after{
\tcontent: "}";
\tcolor: green;
}

.content {
\talign-items: center;
\tflex-direction: column;
\tline-break: strict;
\tborder-radius: 10px;
\tbackground-color: rgba(117, 117, 117, 0.295);
\tpadding: 30px;
\theight: fit-content;
\tdisplay: flex;
\tjustify-content: center;
\twidth: fit-content;
}

.start-editing {
\tmargin-top: 15px;
}

@media (prefers-color-scheme: light) {
\t.content {
\t\tbackground-color: rgba(255, 255, 255, 0.877);
\t\tbox-shadow: 0 0 30px rgba(0, 0, 0, 0.315);
\t\tcolor: rgb(51, 51, 51);
\t}
\t.start-editing {
\t\tcolor: rgb(51, 51, 51);
\t}
\t.background {
\t\tbackground: white;
\t}
}
`);

const someHTMLCodeExample = rTabs(`
<!DOCTYPE html>
<html lang="en">

<head>
\t<meta charset="UTF-8">
\t<meta name="viewport" content="width=device-width, initial-scale=1.0">
\t<title>SamCode - A minimal code editor</title>
</head>

<body>
\t<div class="background">
\t\t<div class="content">
\t\t\t<div class="logo"> SamCode </div>
\t\t\t<div class="tagline">A SIMPLE CODE EDITOR</div>
\t\t</div>
\t\t<div class="start-editing">
\t\t\t<div>Start <abbr title="You can edit code on the left pane">editing</abbr> and preview it here!</div>
\t\t</div>
\t</div>
</body>

</html>
`);

const files = {
  CSS: {
    name: "CSS",
    language: "css",
    value: someCSSCodeExample,
  },
  HTML: {
    name: "HTML",
    language: "html",
    value: someHTMLCodeExample,
  },
};

export default files;
